let guid = 0;

export default function debounce<T extends (...args: any[]) => void>(handler: T, delay?: number, maximumDelay?: number | false | undefined)
{
    if (!delay || isNaN(delay))
    {
        delay = 300;
    }

    if (!maximumDelay || isNaN(maximumDelay) || maximumDelay < delay)
    {
        maximumDelay = false;
    }
    
    let eventTimer: number | undefined | null;
    let debouncingStartTime: number | undefined;

    function debounced(this: any)
    {
        const domElement = this;
        const parameters = arguments;
        function delayed()
        {
            eventTimer = null;
            handler.apply(domElement, parameters as unknown as any[]);
        }

        if (eventTimer) // In the middle of a debounced series of calls 
        {
            window.clearTimeout(eventTimer);
        }
        else if(maximumDelay) // Starting to debounce a new series of calls (with a maximum delay specified) 
        {
            debouncingStartTime = Date.now();
        }

        if (maximumDelay && eventTimer && (Date.now() - debouncingStartTime! > maximumDelay)) // delayed a call to handler for longer than the maximum
        {
            delayed();
        }
        else
        {
            eventTimer = window.setTimeout(delayed, delay);
        }
    }
    debounced.force = function ()
    {
        if (eventTimer) // In the middle of a debounced series of calls 
        {
            window.clearTimeout(eventTimer);
            eventTimer = null;
        }
        handler.apply(this, arguments as unknown as any[]);
    };

    Object.defineProperty(debounced, "isActive",
    {
        get()
        {
            return eventTimer != null;
        }
    });

    return debounced as T & { force: T; isActive: boolean };
};

function jqDebounce<T>(this: JQuery<T>, events: string, handler: Function, delay?: number):                                                              JQuery<T>
function jqDebounce<T>(this: JQuery<T>, events: string, selector: string,  handler: Function, delay?: number):                                           JQuery<T>
function jqDebounce<T>(this: JQuery<T>, events: string, selector: string,  data: any,         handler: Function, delay?: number, maximumDelay?: number): JQuery<T>
function jqDebounce<T>(this: JQuery<T>, events: string, selector: any,     data?: any,        handler?: any,     delay?: any,    maximumDelay?: number)
{
    // Argument Switching
    // TODO (5772911) assign to local variables rather than shuffling args
    const arg1Type = typeof events;
    const arg2Type = typeof selector;
    const arg3Type = typeof data;
    const arg4Type = typeof handler;

    // (events, handler[, delay])
    if (arg1Type === 'string' && arg2Type === 'function')
    {
        handler = selector;
        delay = (data && !isNaN(data)) ? data : null;
        // TODO (5772911) we just overwrote handler. Bug?
        maximumDelay = (handler && !isNaN(handler)) ? handler : undefined;
        selector = null;
        data = null;
    }
        // (events, selector, handler[, delay])
    else if (arg1Type === 'string' && arg2Type === 'string' && arg3Type === 'function')
    {
        delay = (handler && !isNaN(handler)) ? handler : null;
        handler = data;
        maximumDelay = (delay && !isNaN(delay)) ? delay : undefined;
        data = null;
    }
        // (events, selector, data, handler[, delay])
    else if (arg1Type === 'string' && arg2Type === 'string' && arg4Type === 'function')
    {
        events = events;
        selector = selector;
        data = data;
        handler = handler;
        delay = (delay && !isNaN(delay)) ? delay : null;
        maximumDelay = (maximumDelay && !isNaN(maximumDelay)) ? maximumDelay : undefined;
    }

    const debouncedFunction = debounce(handler, delay, maximumDelay);
    // Use the same guid, so the user can remove the event with .off()
    debouncedFunction.guid = handler.guid || (handler.guid = guid++);

    this.on(events, selector, data, debouncedFunction);
    return this;
};
$.fn.debounce = jqDebounce;
// This is needed because webpack internally exports an object with { default: debounce }.
// TODO (5772911) see if we can detect and handle it in webpack/bundleLoader.js
window.skyward.debounce = debounce;